<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">SALDOS DE EMBARQUES</v-card-title>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="3">
                        <date-picker
                            class="float-right"
                            v-model="fecha"
                            @change="cargarSaldos"
                            range-separator="|"
                            range
                            placeholder="Fecha Saldos"
                            format="DD-MM-YYYY"
                            valueType="YYYY-MM-DD"
                        ></date-picker>
                    </v-col>
                </v-row>
                <v-data-table
                    :headers="cabeceras_saldos"
                    :items="saldos"
                    :items-per-page="30"
                    item-class="filita"
                    class="elevation-2 mt-1"
                    dense
                >
                    <template v-slot:item.fecha_reensaque="{ item }">
                        <td class="text-center">{{ item.fecha_reensaque | formatearFecha }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Alert from "@/components/shared/Alert.vue";
//datepicker vue2
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

export default {
    data: () => ({
        fecha: new Date().toISOString().substring(0, 8),
        saldos: [],
        cabeceras_saldos: [
            { text: "ID", align: "center", sortable: true, value: "id", class: "cabecera",},
            { text: "Fecha reensaque", align: "center", sortable: true, value: "fecha_reensaque", class: "cabecera",},
            { text: "Movimiento", align: "center", sortable: true, value: "movimientos_id", class: "cabecera",},
            { text: "Nro Embarque", align: "center", sortable: true, value: "nro_embarque", class: "cabecera",},
            { text: "Folio", align: "center", sortable: true, value: "folio", class: "cabecera",},
            { text: "Lote", align: "center", sortable: true, value: "lote", class: "cabecera",},
            { text: "Saldo", align: "center", sortable: true, value: "saldo", class: "cabecera",},
        ],
    }),

    mounted() {
        this.cargarSaldos();
    },

    methods: {
        async cargarSaldos() {
            let url = `${this.base_url}saldos`;

            if(this.fecha.length === 2) {
                const fecha_ini = this.moment(this.fecha[0]).format('YYYY-MM-DD');
                const fecha_fin = this.moment(this.fecha[1]).format('YYYY-MM-DD');
                url = `?fecha_ini=${fecha_ini}&fecha_fin=${fecha_fin}`;
            }

            await this.axios.get(url, this.headers).then(res => {
                console.log(res);
                this.saldos = res.data.data;
            }).catch(error => {
                console.log(error);
                this.ocultarLoading();
            });
        },
        ...mapMutations(["mostrarLoading", "ocultarLoading"]),
    },
    computed: {
        ...mapState(["base_url", "headers"]),
    },
    components: {
        alert: Alert,
        DatePicker,
    },
};
</script>

<style scoped></style>
